export enum FilterEnum {
    rfrOrdTypeConnect = 'rfrOrdTypeConnect',
    rfrOrdTypeDisconnect = 'rfrOrdTypeDisconnect',
    rfrOrdOnReeferLocationYes = 'rfrOrdOnReeferLocationYes',
    rfrOrdOnReeferLocationNo = 'rfrOrdOnReeferLocationNo',
    rfrOrdHeatingTypeSteam = 'rfrOrdHeatingTypeSteam',
    rfrOrdHeatingTypeElectricity = 'rfrOrdHeatingTypeElectricity',
    rfrOrdHeatingTypeWater = 'rfrOrdHeatingTypeWater',
    rfrOrdDisconnectedYes = 'rfrOrdDisconnectedYes',
    rfrOrdDisconnectedNo = 'rfrOrdDisconnectedNo',
}
